import { DisplayText } from "@classdojo/web/nessie";
import TimerDurationButton from "./TimerDurationButton";
import { IdeasAddIcon } from "components/IdeasIcons";
import { logParentToolkitEvent } from "src/utils/logEvent";

const times = [
  {
    seconds: 15,
    minutes: 0,
    loggingId: "15",
  },
  {
    seconds: 30,
    minutes: 0,
    loggingId: "30",
  },
  {
    seconds: 0,
    minutes: 1,
    loggingId: "1",
  },
  {
    seconds: 0,
    minutes: 5,
    loggingId: "5",
  },
  {
    seconds: 0,
    minutes: 10,
    loggingId: "10",
  },
  {
    custom: true,
    loggingId: "add",
  },
];

type TimerOptionsProps = {
  openTimer: (input: number) => void;
  openCustomModal: VoidFunction;
};

export default function TimerOptions({ openTimer, openCustomModal }: TimerOptionsProps) {
  return (
    <div
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "dt_s",
        position: "relative",
      }}
    >
      <div
        sx={{
          display: "grid",
          gridGap: "dt_s",
          gridTemplateColumns: "1fr 1fr",
          flex: 1,
        }}
      >
        {times.map((time) => {
          const totalSeconds = (time.seconds || 0) + (time.minutes || 0) * 60;
          if (time.custom) {
            return (
              <TimerDurationButton
                key="custom"
                onClick={() => {
                  logParentToolkitEvent({
                    eventName: `timer.${time.loggingId}.tap`,
                  });
                  openCustomModal();
                }}
              >
                <IdeasAddIcon color="dt_content_accent" size="l" />
              </TimerDurationButton>
            );
          }
          return (
            <TimerDurationButton
              key={totalSeconds}
              onClick={() => {
                logParentToolkitEvent({
                  eventName: `timer.${time.loggingId}.tap`,
                });
                openTimer(totalSeconds);
              }}
            >
              <DisplayText level={3}>{`${time.minutes}:${time.seconds === 0 ? "00" : time.seconds}`}</DisplayText>
            </TimerDurationButton>
          );
        })}
      </div>
    </div>
  );
}
